<script>
import { VSelect } from "vuetify/lib";

export default {
  name: "SelectExtend",
  extends: VSelect,
  props: {
    clearable: {
      type: Boolean,
      default: true,
    },
    filled: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    solo: {
      type: Boolean,
      default: true,
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    flat: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    classes() {
      return {...VSelect.options.computed.classes.call(this),
        "v-autocomplete": true,
        "mb-3": true,
      };
    },
  },
};
</script>
